import React from 'react';
import PropTypes from 'prop-types';

import { Text, H4, CPanel } from '@appcues/component-library';

export default function DescriptionPanel({ description }) {
  if (description && description !== '') {
    return (
      <CPanel>
        <H4 marginBottom={16} type="tertiary">
          Description
        </H4>
        <Text>{description}</Text>
      </CPanel>
    );
  }
  return null;
}

DescriptionPanel.propTypes = {
  description: PropTypes.string,
};
